var session = require('../auth/models/session');

module.exports = {
  shouldShowDeveloperReportOptions: function () {
    return session.isDeveloper();
  }
};
